import { Api } from '@/core/api.js'
import { TOOLS } from '@/constants.js'
import { isMutedSensor } from '@/utils/sensorStatus'
import { buildRadarModuleState } from '@/store/utils/radarKpis.js'
import Vue from 'vue'
const api = new Api()

const state = {
    sensors: {},
    sensorValues: {},
    createState: false,
    testoSensors: {},
    testoSensorsInfo: {},
    testoEquipment: {},
    testoReceptors: {},
    sensorStatus: {
        issues: 0,
        alerts: 0,
        connected: 0,
        disconnected: 0,
        offline: 0
    },
    alerts: 0,
    sensorInactive: [],
    sensorHome: {},
    issueCounter: 0,
    alertCounter: 0,
    radarKPIs: null
}

const getters = {
    getList: (state, getters, rootState) => (id) => {
        if (id) {
            return state.sensors[id]
        }
        return state.sensors
    },
    getSensorValues: (state, getters, rootState) => (id) => {
        if (id) {
            return state.sensorValues[id]
        }
        return state.sensorValues
    },
    getTestoSensorsInfo: (state, getters, rootState) => (id) => {
        if(id){
            return state.testoSensorsInfo[id]
        }
        return state.testoSensorsInfo
    },
    getCreateState(state, getters, rootState){
        return state.createState
    },
    getTestoList: (state, getters, rootState) => (id) => {
        if(id){
            return state.testoSensors[id]
        }
        return state.testoSensors
    },
    getTestoSensors: (state, getters, rootState) => () => {
        return state.testoSensors
    },
    getTestoEquipment: (state, getters, rootState) => () => {
        return state.testoEquipment
    },
    getTestoReceptors: (state, getters, rootState) => () => {
        return state.testoReceptors
    },
    getSensorStatus: (state, getters, rootState) => () => {
        return state.sensorStatus
    },
    getAlertsActive: (state, getters, rootState ) => {
        return state.alerts
    },
    getSensorInactive: (state, getters, rootState) => {
        return state.sensorInactive ? Object.values(state.sensorInactive) : []
    },
    getSensorHome: (state, getters, rootState) => {
        return state.sensorHome || {}
    },
    getAlertCounter: (state, getters, rootState) => {
        return state.alertCounter
    },
    getIssueCounter: (state, getters, rootState) => {
        return state.issueCounter
    },
    getRadarModuleState: (state) => (kpiKeys) => {
        const result = buildRadarModuleState(TOOLS.SENSORS, state.radarKPIs, kpiKeys)

        return result
    }
}

const actions = {
    loadList(context, params) {
        return api.get('sensor/devices', {}).then(function (response) {
            if (response.status) {
                const sensors = Object.values(response.data)
                var connected = 0;
                var disconnected = 0;
                var offline = 0;
                sensors.forEach(sensor => {
                    if (sensor.status === 1) {
                        disconnected++
                        if (isMutedSensor(sensor)) {
                            offline++
                        }
                        return
                    }
                    if (isMutedSensor(sensor)) {
                        offline++
                        return
                    }
                    
                    if (sensor.config){
                        if (!sensor.config.condition) {
                            connected++;
                            return
                        }
                        switch(sensor.config.condition){
                            case '>':
                                if(sensor.last_value.value < sensor.config.value){
                                    connected++;
                                }
                                break;
                            case '<':
                                if(sensor.last_value.value > sensor.config.value){
                                    connected++;
                                }
                                break;
                            case '<>':
                                const value = sensor.config.value.split(',');
                                const smallerValue = Number(value[0]);
                                const largerValue = Number(value[1]);
                                if(sensor.last_value.value < smallerValue || sensor.last_value.value > largerValue){
                                    connected++;
                                }
                                break;
                            case '!<>':
                                const valueNot = sensor.config.value.split(',');
                                const smallerValueNot = Number(valueNot[0]);
                                const largerValueNot = Number(valueNot[1]);
                                if(sensor.last_value.value >= smallerValueNot && sensor.last_value.value <= largerValueNot){
                                    connected++;
                                }
                                break;
                            default:
                                disconnected++;
                                break;
                        }
                    } else if (!sensor.config && sensor.status === 2) {
                        connected++;
                    }
                })
                context.commit('setSensorStatus', { connected, disconnected, offline })
                const { issues, alerts } = context.state.sensorStatus
                context.commit('setRadarKPIValues', {
                    total: sensors.length,
                    kpis: [
                        { key: 'sensors_without_data', value: disconnected },
                        { key: 'sensors_muted', value: offline },
                        { key: 'sensors_with_issues', value: issues },
                        { key: 'sensors_with_alert', value: alerts }
                    ]
                })
            }
            return response.status ? context.commit('setList', response.data) : false
        })
    },
    syncWithRmoniApi(context) {
        return api.get('sensor/rmoni/sync', {}).then(function (response) {
            return response.status
        })
    },
    syncWithTestoApi(context, {account_id, location_id, c = -1}) {
        if(!account_id || !location_id){
            //log('syncWithTestoApi', 'account_id or location_id is required', account_id, location_id)
            return false
        }
        //Poner c=1 si es rbe
        let url = `cron/cron_testo_update_metadata/${account_id}/${location_id}`;
        if(c === 1){
            url += '?c=1';
        }
        return api.get(url).then(function (response) {
            return response.status
        })
    },
    loadTestoDevices(context, params) {
        return api.get('sensor/testo/devices', {}).then(function (response) {
            if(response.status){
                context.commit('setTestoSensors', response.data.sensors)
                context.commit('setTestoEquipment', response.data.equipment)
                context.commit('setTestoReceptors', response.data.receptors)
                return true
            }else{
                return false
            }
        })
    },
    loadSensorValues(context, params) {
        // pasar parametro fecha
        return api.post('sensor/values', params || {}).then(function (response) {
            if (response.status) {
                const sensors = context.state.sensors || {}
                var issues = 0;
                var alerts = 0;
                var issueCounter = 0;
                var alertCounter = 0;
                const values = Object.values(response.data || {})
                Object.entries(response.data || {}).forEach(([sensorId, value]) => {
                    const sensor = sensors[sensorId]
                    issueCounter += (Number(value.issues))
                    alertCounter += (Number(value.alerts))

                    if (sensor && sensor.status === 1) return

                    if (value.issues > 0) {
                        issues++;
                        return;
                    }
                    if (value.alerts > 0) {
                        alerts++;
                        return;
                    }
                })
                context.commit('setSensorStatus', { issues, alerts })
                context.commit('setSensorAlertsAndIssues', {issueCounter, alertCounter});
                context.commit('setTestoSensorsInfo', values)

                const total = Object.keys(context.state.sensors).length
                const { disconnected, offline } = context.state.sensorStatus
                context.commit('setRadarKPIValues', {
                    total,
                    kpis: [
                        { key: 'sensors_with_issues', value: issues },
                        { key: 'sensors_without_data', value: disconnected },
                        { key: 'sensors_with_alert', value: alerts },
                        { key: 'sensors_muted', value: offline }
                    ]
                })
            }
            return response.status ? context.commit('setSensorValues', response.data) : false
        })

    },
    loadSensorValuesDetail(context, params) {
        // pasar parametro fecha
        return api.post('sensor/values/' + params.id, params).then(function (response) {
            return response.status ? context.commit('setSensorValue', { id: params.id, data: response.data[params.id] }) : false
        })
    },

    loadSensorOpenIssues(context, params) {
        // pasar parametro
        // id o sin id
        params = params || ''
        return api.post('sensor/issues' + (params && params.sensor_id ? '/' + params.sensor_id : ''), params).then(function (response) {
            if(response.status && params == '') {
                context.commit('setAlerts', Object.keys(response.data).length)
            }
            return response.status ? response.data : false
        })
    },

    loadSensorOpenIssuesBySensor(context, params) {
        const sensorId = params.sensor_id || params
        const payload = {
            sensor_id: sensorId,
            offset: params.offset != null ? params.offset : 0,
            limit: params.limit != null ? params.limit : 21
        }
        return api.post('sensor/issues/open/' + sensorId, payload).then(function (response) {
            if (!response.status) {
                return false
            }
            const data = response.data || {}
            return {
                results: data.data || {},
                total: Number(data.results) || 0
            }
        })
    },

    addSensor(context, params) {
        if (params.newVal) {
            params.sensor.config.value = params.newVal
        }
        params.sensor.config = JSON.stringify(params.sensor.config)
        let sensor = params.sensor
        return api.post('sensor/add', sensor).then(function (response) {
            context.commit('addSensor', response.data)
            return true
        })
    },
    editSensor(context, params) {
        params.sensor.sensor_id = params.sensor.id
        if (params.newVal) {
            params.sensor.config.value = params.newVal
        }
        params.sensor.config = JSON.stringify(params.sensor.config)
        let sensor = params.sensor
        return api.post('sensor/update', sensor).then(function (response) {
            context.commit('editSensor', response.data)
            return true
        })
    },
    removeSensor(context, params) {
        return api.post('sensor/delete', { sensor_id: params }).then(function (response) {
            context.commit('removeSensor', params)
            return true
        })
    },
    updateSensorEquipment(context, params) {
        // Tomar snapshot previo para rollback
        const sensorId = params.sensor_id
        const stateSensors = context.state.testoSensors || {}
        const currentSensor = (stateSensors.related && stateSensors.related[sensorId])
            ? stateSensors.related[sensorId]
            : (stateSensors.unrelated && stateSensors.unrelated[sensorId])
                ? stateSensors.unrelated[sensorId]
                : null
        const previousEquipmentId = currentSensor ? (currentSensor.equipment || null) : null

        // Update optimista
        context.commit('updateSensorEquipment', params)

        return api.post('sensor/update/equipment', params).then(function (response) {
            if (response && response.status) {
                return true
            }
            // Rollback si la API responde error
            context.commit('updateSensorEquipment', { sensor_id: sensorId, equipment_id: previousEquipmentId })
            return Promise.reject(response || { status: false })
        }).catch(function (error) {
            // Rollback por excepción de red/servidor
            context.commit('updateSensorEquipment', { sensor_id: sensorId, equipment_id: previousEquipmentId })
            return Promise.reject(error)
        })
    },
    loadSensorInactive(context, params) {
        return api.get('sensor/inactive', params).then(function (response) {
            if(response.status){
                context.commit('setSensorInactive', response.data)
            }
            return response.status
        })
    },
    activateSensorAlert(context, params) {
        return api.post('sensor/activate/alert', params).then(function (response) {
            return response.status
        })
    },
    loadSensorHistory(context, params) {
        return api.post('sensor/history', params).then(function (response) {
            if (!response || !response.status) {
                return { items: [], previous: null }
            }

            return {
                items: Array.isArray(response.data) ? response.data : [],
                previous: response.previous || null
            }
        })
    },
    loadSensorHome(context, params) {
        return api.get('sensor/home', params).then(function (response) {
            if (response.status) {
                context.commit('setSensorHome', response.data)
            }
            return response.status
        })
    },
    deleteTestoSensor(context, params) {
        return api.post('sensor/testo/delete', { sensor_ids: params }).then(function (response) {
            return response.status
        })
    }
}

const mutations = {
    setCreateState(state,data){
        state.createState = data
    },
    setList(state, data) {
        state.sensors = data
    },
    setSensorValues(state, data) {
        state.sensorValues = data
    },
    setSensorValue(state, payload) {
        let sensorValues = state.sensorValues
        sensorValues[payload.id] = payload.data
        state.sensorValues = { ...sensorValues }
        Vue.set(state, 'sensorValues', { ...state.sensorValues })
    },
    setTestoSensorsInfo(state, data) {
        const newSensorsInfo = {} // { sensor_id: { issuesList: [], alertsList: [] } }
        if(data){
            data.forEach(sensor => {
                const sensorInfo = { issuesList: [], alertsList: sensor.alerts ? sensor.alerts : 0}
                Object.values(sensor.values).forEach(value => {
                    if(value.issue){
                        sensorInfo.issuesList.push(value)
                    }
                });
                newSensorsInfo[sensor.id] = sensorInfo
            });
        }
        Vue.set(state, 'testoSensorsInfo', newSensorsInfo)
        state.testoSensorsInfo = newSensorsInfo
    },
    updateSensorEquipment(state, data) {
        // Actualizar el sensor en la estructura de testoSensors
        const sensorId = data.sensor_id
        const equipmentId = data.equipment_id

        // Buscar el sensor en ambas listas
        let sensor = null
        let foundInRelated = false

        if (state.testoSensors.related && state.testoSensors.related[sensorId]) {
            sensor = state.testoSensors.related[sensorId]
            foundInRelated = true
        } else if (state.testoSensors.unrelated && state.testoSensors.unrelated[sensorId]) {
            sensor = state.testoSensors.unrelated[sensorId]
            foundInRelated = false
        }

        if (sensor) {
            // Actualizar el equipo del sensor
            sensor.equipment = equipmentId

            // Mover el sensor a la lista correspondiente
            if (equipmentId && equipmentId !== 'null') {
                // Mover a sensores vinculados
                if (!foundInRelated) {
                    // Remover de unrelated
                    delete state.testoSensors.unrelated[sensorId]
                    // Agregar a related
                    state.testoSensors.related[sensorId] = sensor
                }
            } else {
                // Mover a sensores no vinculados
                if (foundInRelated) {
                    // Remover de related
                    delete state.testoSensors.related[sensorId]
                    // Agregar a unrelated
                    state.testoSensors.unrelated[sensorId] = sensor
                }
            }

            // Actualizar el estado reactivo
            Vue.set(state, 'testoSensors', { ...state.testoSensors })
        }
    },
    addSensor(state, data) {
        let sensors = state.sensors
        sensors[data.id] = data
        state.sensors = { ...sensors }
        Vue.set(state, 'sensors', { ...state.sensors })
    },
    editSensor(state, data) {
        let sensors = state.sensors
        sensors[data.id] = data
        state.sensors = { ...sensors }
        Vue.set(state, 'sensors', { ...state.sensors })
    },
    removeSensor(state, payload) {
        let sensors = state.sensors
        delete sensors[payload]
        state.sensors = { ...sensors }
        Vue.set(state, 'sensors', { ...state.sensors })
    },

    setTicket(state, data) {
        let tickets = state.tickets
        tickets[data.id] = data
        state.tickets = { ...tickets }
        Vue.set(state, 'tickets', { ...state.tickets })
    },
    setTestoSensors(state, data) {
        if(data){
            const newSensors = {
                related: {},
                unrelated: {}
            }
            data.forEach(sensor => {
                sensor.metadata = sensor.metadata
                    ? (typeof sensor.metadata === 'object' ? sensor.metadata : JSON.parse(sensor.metadata))
                    : {}
                if(sensor.equipment){
                    newSensors.related[sensor.id] = sensor
                }else{
                    newSensors.unrelated[sensor.id] = sensor
                }
            })
            Vue.set(state, 'testoSensors', newSensors)
            state.testoSensors = newSensors
        }
    },
    setTestoEquipment(state, data) {
        Vue.set(state, 'testoEquipment', data)
        state.testoEquipment = data
    },
    setTestoReceptors(state, data) {
        if(data){
            const newReceptors = {}
            data.forEach(receptor => {
                receptor.metadata = receptor.metadata
                    ? (typeof receptor.metadata === 'object' ? receptor.metadata : JSON.parse(receptor.metadata))
                    : {}
                newReceptors[receptor.id] = receptor
            })
            Vue.set(state, 'testoReceptors', newReceptors)
            state.testoReceptors = newReceptors
        }
    },
    setSensorStatus(state, payload) {
        state.sensorStatus = {
            ...state.sensorStatus,
            ...payload
        }
    },
    setAlerts(state, payload) {
        state.alerts = payload
    },
    setSensorInactive(state, payload) {
        state.sensorInactive = payload
        Vue.set(state, 'sensorInactive', { ...state.sensorInactive })
    },
    setSensorHome(state, payload) {
        state.sensorHome = payload
        Vue.set(state, 'sensorHome', { ...state.sensorHome })
    },
    setSensorAlertsAndIssues(state, payload) {
        state.issueCounter = payload.issueCounter
        state.alertCounter = payload.alertCounter
    },
    setRadarKPIs(state, radarKPIs) {
        state.radarKPIs = radarKPIs
    },
    setRadarKPIValues(state, { total, kpis }) {
        const kpiMap = {}
        kpis.forEach(({ key, value }) => { kpiMap[key] = value })

        if (!state.radarKPIs) {
            state.radarKPIs = {
                total,
                kpis: kpis.map(({ key, value }) => ({ key, value }))
            }
            return
        }

        const existingKpis = Array.isArray(state.radarKPIs.kpis) ? state.radarKPIs.kpis : []
        const existingKeys = new Set(existingKpis.map((k) => k.key))

        const updatedKpis = existingKpis.map((rawKpi) => {
            if (kpiMap[rawKpi.key] !== undefined) {
                return { ...rawKpi, value: kpiMap[rawKpi.key] }
            }
            return rawKpi
        })

        kpis.forEach(({ key, value }) => {
            if (!existingKeys.has(key)) {
                updatedKpis.push({ key, value })
            }
        })

        state.radarKPIs = { ...state.radarKPIs, total, kpis: updatedKpis }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
